import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const KIOSKSHOPPAGE_LEGACY_FIELD_ORDER = [
  "background_color",
  "background_image",
  "text_color",
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  kioskShopPageDescriptor: _generatedKioskShopPageDescriptor,
  kioskShopPageBlocDefinition,
  kioskShopPageDashboardLayout,
  kioskShopPageConfig,
  kioskShopPageResolveConfig,
  kioskShopPageProperties,
} = doodBlockConfig(
  {
    name: "Kiosk - Shop page",
    internal_name: "Kiosk - Shop page",
    url: ":shopCity/:shopType/:shopSlug",
    defaultParent: [/^Main Layout$/i],
    componentType: 'KioskShopPageComponent',
    category: 'page',
    description: "Kiosk - Shop page.",
    keywords: [],
    isRootBlock: true,
    sharedFields: {}
,
    slots: [
      {
        key: 'header',
        name: "pages.blocks.kiosk-shop-page.header.label",
        accept: 'explicitOnly',
        allowedTypes: ["KioskHeaderBlock"],
        slotItemFormat: 'ids',
        defaultBlocks: [
          { id: 'kiosk-header-block', type: 'KioskHeaderBlockComponent' },
        ],
      },
      {
        key: 'sidebar',
        name: "pages.blocks.kiosk-shop-page.sidebar.label",
        accept: 'explicitOnly',
        allowedTypes: ["KioskShopCategoryListBlock"],
        slotItemFormat: 'ids',
        defaultBlocks: [
          {
            id: 'kiosk-shop-category-list-block',
            type: 'KioskShopCategoryListBlockComponent',
          },
        ],
      },
      {
        key: 'footer',
        name: "pages.blocks.kiosk-shop-page.footer.label",
        accept: 'explicitOnly',
        allowedTypes: ["KioskFooterCartBlock"],
        slotItemFormat: 'ids',
        defaultBlocks: [
          { id: 'kiosk-footer-cart-block', type: 'KioskFooterCartBlockComponent' },
        ],
      }
    ]
  },

  () => ({
    background_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#FFFFFF"},
      options: {
        label: "pages.blocks.kiosk-shop-page.background-color.label",
      }
    }),
    background_image: propertyValue({
      type: 'image',
      value: '',
      options: {
        label: "pages.blocks.kiosk-shop-page.background-image.label",
        help: "pages.blocks.kiosk-shop-page.background-image.help",
      }
    }),
    text_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#000"},
      options: {
        label: "pages.blocks.kiosk-shop-page.text-color.label",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.kiosk-shop-page.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.kiosk-shop-page.fieldset.appearance.label",
            fields: ["background_color", "background_image", "text_color"],
          },
          {
            legend: "pages.blocks.kiosk-shop-page.fieldset.blocks.label",
            fields: ["header", "sidebar", "footer"],
          },
        ],
      },
    ],
  })
);

export function kioskShopPageDescriptor(): IBlockDescriptor;
export function kioskShopPageDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function kioskShopPageDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedKioskShopPageDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedKioskShopPageDescriptor, kioskShopPageProperties, fieldOrder);
}

export {
  kioskShopPageBlocDefinition,
  kioskShopPageDashboardLayout,
  kioskShopPageProperties,
  kioskShopPageConfig,
  kioskShopPageResolveConfig,
};

export type KioskShopPageConfig = typeof kioskShopPageConfig;
